import React, { useCallback, useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import CustomButton from "components/common/Button/CustomButton";
import ServiceSupportModal from "./ServiceSupportModal";
import ServiceSupportTable from "./ServiceSupportTable";
import { FaRegFilePdf } from "react-icons/fa";
import { baseURLImage } from "Utils/utils";

const ServiceSupport = (props) => {
  const {
    selectedFunding,
    participant,
    getPlanBudgetCatAndSubCat,
    externalSps,
    getCatalogServicesSubCategory,
    catalogStates,
    serviceSupportCreate,
    createServiceSupportLoader,
    createServiceSupportError,
    getServiceSupportList,
    serviceSupportBudgets,
    fetchServiceSupportLoader,
    getQoutationPdfPath,
  } = props;

  const [openModal, setOpenModal] = useState(false);
  const [serviceSupportItem, setServiceSupportItem] = useState(null);
  const hasLineItems = serviceSupportBudgets?.data?.length > 0;

  useEffect(() => {
    if (selectedFunding && participant && externalSps.length === 0) {
      getPlanBudgetCatAndSubCat({
        funding_reference_id: selectedFunding.contract_id,
        pt_id: participant.uuid,
      });
    }
    if (!catalogStates) {
      getCatalogServicesSubCategory({ isService: false });
    }
  }, []);

  useEffect(() => {
    if (getQoutationPdfPath) {
      window.open(baseURLImage(getQoutationPdfPath), "_blank");
    }
  }, [getQoutationPdfPath,]);

 const handleGenerateQuotation = useCallback(() => {
  getServiceSupportList({
    pt_id: participant.uuid || 1,
    funding_id: selectedFunding.id || 1,
    reporting_pdf: 1,
    funding_reference_id: selectedFunding.contract_id,
  });
}, [participant.uuid, selectedFunding.id, selectedFunding.contract_id, getServiceSupportList]);

  return (
    <div className='w-full py-3 bg-white'>
      <div>
        <div>
          <div className='flex justify-between items-center px-6 bg-gray-25 border md:rounded-t-lg font-bold text-lg text-gray-900 py-4'>
            <div>Service Support</div>
            <div className='flex gap-x-2'>

<div 
    title={!hasLineItems ? "Add at least one line item to enable this option." : ""}
    className="inline-block"
  >
    <CustomButton
                label='Generate Quotation'
                clickHandler={() => handleGenerateQuotation()}
                Icon={<FaRegFilePdf className='text-white' />}
                isDisabled={fetchServiceSupportLoader || !hasLineItems}
                showLoading={fetchServiceSupportLoader}
                cssClass='border-0 z-2'
                tooltip={!hasLineItems ? "Add at least one line item to enable this option." : ""}
              />
    </div>
              <CustomButton
                label='Service Support Budget'
                clickHandler={() => setOpenModal(true)}
                Icon={<BiPlus />}
                cssClass='border-0'
              />
            </div>
          </div>
        </div>
        <div>
          <ServiceSupportTable
            getServiceSupportList={getServiceSupportList}
            funding={selectedFunding}
            participant={participant}
            serviceSupportBudgets={serviceSupportBudgets}
            // planBudgets={planBudgets}
            fetchLoader={fetchServiceSupportLoader}
            // removeLoader={removePlanBudgetLoader}
            // removePlanBudget={removePlanBudget}
            setServiceSupportItem={setServiceSupportItem}
          />
        </div>
      </div>

      {(openModal || serviceSupportItem !== null) && (
        <ServiceSupportModal
          openModal={openModal || serviceSupportItem !== null}
          closeModal={() => {
            setOpenModal(false);
            setServiceSupportItem(null);
          }}
          catalogStates={catalogStates}
          externalSps={externalSps}
          //   PlanCatagories={PlanCatagoriesList}
          funding={selectedFunding}
          serviceSupportCreate={serviceSupportCreate}
          createServiceSupportLoader={createServiceSupportLoader}
          createServiceSupportError={createServiceSupportError}
          participant={participant}
          serviceSupporitemEdit={serviceSupportItem}
        />
      )}
    </div>
  );
};

export default ServiceSupport;
